import { render } from "./left-thin.svg?vue&type=template&id=52f1bbc4"
const script = {}

import exportComponent from "/Users/mcoombes/Dev/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__